export const meta = {
  alias: 'click-to-call',
  name: 'Click To Call',
  prefix: 'eapp-click-to-call'
} as const;
